import React, { useEffect, useReducer, useRef, useState } from 'react'
import styled, { useTheme } from 'styled-components'
import { ReactComponent as ReactionIcon } from '../../Assets/icons/ReactionIcon.svg'
import { ReactionBarSelector } from '@charkour/react-reactions';
import { reactionButtonEmojiItems, mapKey } from '../../Constants/emojiList';
const ReactionButton = ({ 
    id, 
    handleReactToMessage, 
    handleRemoveOwnMessageReaction,
    messageId, 
    conversationId, 
    userId, 
    reactions, 
    setShowReactionButton 
}) => {
    const ref = useRef();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const theme = useTheme()
    var letftDistance = 185;

    const handleOpen = () => {
        setIsMenuOpen(!isMenuOpen)
    }

    if (ref.current) {
        letftDistance = ref.current.offsetLeft;
    }

    useEffect(() => {
        const checkIfClickedOutside = (e) => {
            if (isMenuOpen && ref.current && !ref.current.contains(e.target)) {
                setIsMenuOpen(false);
            }
        };
        document.addEventListener("mousedown", checkIfClickedOutside);
        return () => {
            // Cleanup the event listener
            document.removeEventListener("mousedown", checkIfClickedOutside);
        };
    }, [isMenuOpen]);


    return (
        <Container ref={ref} id={id}>
            <ReactionBtn onClick={() => handleOpen()}>
                <ReactionIcon />
            </ReactionBtn>
            {isMenuOpen &&
                <ReactionsContainer letftdistance={letftDistance}>
                    <ReactionBarSelector
                        iconSize={20}
                        style={{
                            zIndex: 2,
                            background: theme.chat.selectedBackground
                        }}
                        reactions={reactionButtonEmojiItems}
                        onSelect={(e) => {
                            const r = reactions.find(r => mapKey(r.reaction) === e);
                            if (r && r.user_id === userId) {
                                handleRemoveOwnMessageReaction(r.id, conversationId, messageId, () => {
                                    setShowReactionButton(false)
                                });
                                return;
                            }
                            handleReactToMessage(e, conversationId, messageId, () => {
                                setShowReactionButton(false)
                            });
                        }}
                    />
                </ReactionsContainer>}


        </Container>
    )
}

export default ReactionButton
const Container = styled.div`
position:absolute;
right:-50px;
`
const ReactionBtn = styled.div`
display:flex;
justify-content:center;
align-items:center;
 background: ${({ theme }) => theme.chat.selectedBackground};
width:42px;
height:42px;
border-radius:100%;
border:none;
cursor:pointer;
svg{
 color: ${({ theme }) => theme.sidebar.iconColor};
}
`
const ReactionsContainer = styled.div`
display:flex;
align-items:center;
justify-content:center;
position:absolute;
top:-40px;
right:${(props) => props.letftdistance < 184 ? props.letftdistance : 0};
border-radius:100px;
 background: ${({ theme }) => theme.chat.selectedBackground};
`